export default __webpack_public_path__ + "assets/ico_instagram-b6f08baa.svg";